// Mirror of api/api/helper/refCode.js - keep both in sync. The API is authoritative;
// this copy only drives the live preview in the add-code dialog.
export const REF_CODE_MIN = 6;
export const REF_CODE_MAX = 100;

const TR_MAP = {
  'ı': 'i', 'İ': 'i', 'ş': 's', 'Ş': 's', 'ğ': 'g', 'Ğ': 'g',
  'ü': 'u', 'Ü': 'u', 'ö': 'o', 'Ö': 'o', 'ç': 'c', 'Ç': 'c'
};

export const normalizeRefCode = (value) => String(value === undefined || value === null ? '' : value)
  .replace(/[ıİşŞğĞüÜöÖçÇ]/g, (c) => TR_MAP[c])
  .toLowerCase()
  .normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const isValidRefCode = (normalized) =>
  normalized.length >= REF_CODE_MIN && normalized.length <= REF_CODE_MAX;
